import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function OverallPerformanceCard({result}) {
  return (
    <div className="overall-performance card-default-style d-flex h-100 py-25 px-10">
      <div className="Progress-holder position-relative">
        <CircularProgressbar
          value={result}
          circleRatio={0.76}
          strokeWidth={12}
          styles={buildStyles({
            strokeLinecap: "round",
            textColor: "red",
            pathColor: "#F05203",
            trailColor: "gold",
            rotation: 1 / 2 + 1 / 8,
            trailColor: "transparent",
          })}
        />
        <div className="detail">
          <div className="icon ah-text-base mx-auto mb-7 d-flex justify-content-center align-items-center rounded-circle">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.33887 0.725586C9.39973 0.725586 10.4171 1.14701 11.1673 1.89716C11.9174 2.6473 12.3389 3.66472 12.3389 4.72559C12.3389 5.78645 11.9174 6.80387 11.1673 7.55401C10.4171 8.30416 9.39973 8.72559 8.33887 8.72559C7.278 8.72559 6.26059 8.30416 5.51044 7.55401C4.76029 6.80387 4.33887 5.78645 4.33887 4.72559C4.33887 3.66472 4.76029 2.6473 5.51044 1.89716C6.26059 1.14701 7.278 0.725586 8.33887 0.725586ZM8.33887 10.7256C12.7589 10.7256 16.3389 12.5156 16.3389 14.7256V16.7256H0.338867V14.7256C0.338867 12.5156 3.91887 10.7256 8.33887 10.7256Z"
                fill="#F05203"
              />
            </svg>
          </div>
          <h3 className="ah-heading-04 fw-bold black-800 mb-10">{result}</h3>
          <p className="ah-text-sm fw-bold black-800 mb-0">{"Excellent"}</p>
        </div>
        <button className="btn btn-soft-green py-10 mt-35 border-0 shadow-none min-w-auto w-100">
          See Details
        </button>
      </div>
    </div>
  );
}
